import React, { Component } from "react";
import PropTypes from "prop-types";
import { Field, FieldArray } from "redux-form";
import { connect } from "react-redux";
import { createDiscrepancy } from "MODULES/Receiving/actions";
import {
  form,
  Form as AppForm,
  FormInput,
  Select,
  TextArea,
  FileInput
} from "MODULES/shared/components/Forms";
import { DashedSeparator } from "MODULES/shared/components";
import { toOptions } from "LIB/forms";
import validate from "./validate";
import { DISCREPANCY_TYPES } from "../../constants";

class Discrepancy extends Component {
  componentDidMount() {
    if (this.props.fields.length < 1) {
      this.props.fields.push();
    }
  }

  render() {
    const { fields, discrepancies } = this.props;
    const showAddButton = fields.length < 5;
    return (
      <div>
        {fields.map((discrepancy, index) => (
          <div key={`discrepancy-${discrepancy + index}`}>
            <h5 className="h4">
              Discrepancy #{index + 1}
              {index !== 0 &&
                !discrepancies[index] && (
                  <button
                    type="button"
                    className="btn btn-xs btn-default btn-hollow pull-right"
                    onClick={() => fields.remove(index)}
                  >
                    <i className="fa fa-fw fa-ban" />
                    &nbsp;Remove
                  </button>
                )}
            </h5>
            <div className="row">
              <div className="col-md-5">
                <div className="row">
                  <div className="col-md-12">
                    <Field
                      name={`${discrepancy}.discrepancy_type`}
                      component={Select}
                      label="Discrepancy Type"
                      options={toOptions(DISCREPANCY_TYPES)}
                      disabled={discrepancies[index]}
                      required
                    />
                  </div>
                  <div className="col-md-12">
                    <Field
                      name={`${discrepancy}.files`}
                      component={FileInput}
                      label="Upload Attachment(s)"
                      multiple
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <Field
                  name={`${discrepancy}.reason`}
                  component={TextArea}
                  label="Explain the Discrepancy"
                  rows={5}
                />
              </div>
            </div>
          </div>
        ))}
        {showAddButton && (
          <button
            type="button"
            onClick={() => fields.push()}
            className="btn btn-primary btn-hollow"
            style={{ marginTop: 5, marginBottom: 15 }}
          >
            <i className="fa fa-fw fa-plus" /> Add another Discrepancy
          </button>
        )}
      </div>
    );
  }
}

Discrepancy.propTypes = {
  discrepancies: PropTypes.shape({
    id: PropTypes.number
  }),
  fields: PropTypes.shape({
    length: PropTypes.number,
    push: PropTypes.func
  })
};

export function Form(props) {
  const { discrepancies } = props;

  return (
    <AppForm {...props}>
      <AppForm.Body>
        <div className="row row-col-gutters-half">
          <div className="col-md-6">
            <Field
              name="read_only_part_number"
              component={FormInput}
              label="Part #"
              disabled
            />
          </div>
          <div className="col-md-6">
            <Field
              name="read_only_serial_number"
              component={FormInput}
              label="Serial #"
              disabled
            />
          </div>
        </div>
        <DashedSeparator />
        <FieldArray
          name="discrepancies"
          discrepancies={discrepancies}
          component={Discrepancy}
        />
      </AppForm.Body>
    </AppForm>
  );
}

Form.propTypes = {
  discrepancies: PropTypes.shape({})
};

export default connect(undefined, { onSubmit: createDiscrepancy })(
  form({
    form: "addDiscrepancy",
    validate
  })(Form)
);



// WEBPACK FOOTER //
// ./app/modules/Receiving/Detail/Discrepancies/Form.jsx